import { schema } from 'normalizr'
export const channelSubscriptionSchema = new schema.Entity(
  'channel_subscriptions',
  {},
  {
    idAttribute: 'id'
  }
)
